export const ROLES = {
  TAB: 0,
  TAB_LIST: 1,
  TABBED_VIEW: 2,
  TAB_PANEL: 3,
};
